import { ELanguage } from '@microfrontends/react-components'

interface IOpenToWork {
    isOpenToWork: 0 | 1
    langCode: ELanguage
    accessToken: string
}

const OPEN_TO_WORK_ENDPOINT = 'api-gateway/v1.0/profile/open-to-work'
const DOMAIN = process.env.NEXT_PUBLIC_MS_BASE_PATH ?? ''

export type TRespone = {
    code: number
    message: string
    id: 0
    error: string
}

export const makePofileOpenToWork = async ({
    isOpenToWork,
    langCode,
    accessToken
}: IOpenToWork): Promise<TRespone | null> => {
    try {
        const response = await fetch(`${DOMAIN}/${OPEN_TO_WORK_ENDPOINT}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
                'Accept-Language': langCode
            },
            body: JSON.stringify({ isOpenToWork: isOpenToWork })
        })
        const data = await response.json()
        if (!data || data.error) {
            console.error(data.error)
            return null
        }
        return data.message
    } catch (err) {
        console.error(err)
        return null
    }
}
